import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Edit } from '@material-ui/icons'

import SimpleInputField from '../../../../PropertySearch/Custom/CustomInput/SimpleInputField'
import listContext from '../../../../Common/context/context'
import searchContext from '../../../../PropertySearch/FiltersComponent/context/context'
import updatePropertyList from '../../../Utility/UpdatePropertyList/UpdatePropertyList'
import { pollMessageStatus } from '../../../Utility/GetMessageStatus/GetMessageStatus'
import { getErrorAlertDuration } from '../../../../PropertySearch/Utility/Utility'

const RenameList = props => {

    const { propertyList, setPropertyList } = useContext(listContext)
    const { savedSearch, setShowAlert, setalertProps, fetchSavedLists, openModalWindow } = useContext(searchContext)
    const [saveClicked, setSaveClicked] = useState(false)
    let [listName, setListName] = useState(propertyList.name)

    useEffect(() => {
        if (saveClicked) {
            handleSave()
        }
    }, [saveClicked])

    function handleChange(e) {
        let { value } = e.target
        setListName(value)
    }

    const onUpdate = (message, type) => {

        try {

            if (type === 'success') {
                let newPropertyList = { ...propertyList }
                newPropertyList.name = listName
                setPropertyList(newPropertyList)
                fetchSavedLists()
            }
            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)
            openModalWindow(false)

        } catch (error) {
            console.log(' error in on-Update :: ', error)
        }

    }

    const handleSave = async () => {
        try {
            let newListName = listName.trim().replace('[ \t]+$')
            setListName(newListName)

            let fieldsToUpdate = []
            let omniViewPropertyListId = propertyList.omniViewPropertyListId
            let polarisPropertySearchCriteriaId = propertyList.polarisPropertySearchCriteriaId

            let index = savedSearch.findIndex(x => x.name === newListName && x.isCart)

            if (index !== -1) {
                let msg = <>List with Name <strong>{newListName}</strong> already exist!!</>
                setalertProps({ message: msg, type: 'error' })
                setShowAlert(true)
                setSaveClicked(false)
                return
            }

            fieldsToUpdate.push({ key: 'compType', value: propertyList.compType })
            fieldsToUpdate.push({ key: 'omniViewPropertyListId', value: omniViewPropertyListId })
            fieldsToUpdate.push({ key: 'polarisPropertySearchCriteriaId', value: polarisPropertySearchCriteriaId })
            fieldsToUpdate.push({ key: 'name', value: newListName })

            const updatePropertyListObj = new updatePropertyList(fieldsToUpdate)
            setSaveClicked(false)
            openModalWindow(true)
            props.closeModal()
            const response = await updatePropertyListObj.update()

            if (response && response.status === 200) {
                pollMessageStatus(response.data.messageId, onUpdate, '', 'List name updated !!', 'Something went wrong !!')
            } else {
                const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
                setalertProps({ message: errorMessage, type: 'error' })
                setShowAlert(true)
            }
        }
        catch (e) {
            console.log('Error handleSave:: ', e)
        }
    }

    return (
        <>
            <div data-testid="test-div-container-rename-list" className='flex flex-col py-4 gap-4 drawer-w'>
                <div className='flex flex-row border-b-1 border-base px-4 pb-2'>
                    <span className='pb-4'>
                        <Edit fontSize="small" />
                    </span>
                    <span className='px-2'>
                        Rename list
                    </span>
                </div>
                <div className='pt-4 pb-8 border-b-1 border-base px-8 flex flex-col gap-2'>
                    <div className="mb-3">
                        <SimpleInputField data-testid='test-input-rename-list' value={listName} onChange={handleChange} type='' placeholder=''></SimpleInputField>
                    </div>
                </div>
                <div className='py-2 px-4'>
                    <div className='flex justify-end space-x-4 mt-auto'>
                        <div>
                            <button data-testid='test-button-cancel' onClick={props.closeModal} className='btn btn-sm' type='button'>
                                Close
                            </button>
                        </div>
                        <div>
                            {saveClicked ?
                                <button className="btn btn-sm btn-primary c-disabled">
                                    <span className="loader h-5 w-5 mx-2" ></span>
                                    <span className="px-2">Saving</span>
                                </button>
                                :
                                <button data-testid='test-button-apply' onClick={() => { setSaveClicked(true) }} className={`btn btn-sm btn-primary ${listName.length === 0 ? 'c-disabled' : ''}`}>Rename list</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RenameList

RenameList.propTypes = {
    closeModal: PropTypes.func,
}